import gql from "graphql-tag";

export default {
update: gql`
    mutation UpdatePhotoboothLandscapeCell ($input: UpdatePhotoboothLandscapeCellInput!) {
        updatePhotoboothLandscapeCell (input: $input) {
            id
            send_email
            gif_uri
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            qr_card_background_color
            button_download_text
            button_retake_text
            button_take_text
            send_text
            sent_text
            look_text
            description_text
            conditions1_text
            conditions2_text
            email
            qr_code
            print
            cameralabel
            orientation
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
            }
        }
    }`,

get: gql`
    query PhotoboothLandscapeCell($id: ID!) {
        photoboothLandscapeCell(id: $id) {
            id
            send_email
            gif_uri
            background_color
            text_color
            button_download_background_color
            button_download_text_color
            button_retake_background_color
            button_retake_border_color
            button_retake_text_color
            button_print_background_color
            qr_card_background_color
            button_download_text
            description_text
            conditions1_text
            conditions2_text
            email
            qr_code
            print
            cameralabel
            orientation
            i18n{
                button_download_text
                button_retake_text
                button_take_text
                send_text
                sent_text
                look_text
                description_text
                conditions1_text
                conditions2_text
            }
        }
    }`
}
